"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends3 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _TickIcon = _interopRequireDefault(require("./TickIcon"));

var _TickIconSmall = _interopRequireDefault(require("./TickIconSmall"));

var _mixins = require("../utils/mixins");

var _theme = require("../theme");

var _focusSource = require("../utils/focus-source");

function _createSuper(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = (0, _getPrototypeOf2.default)(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2.default)(this, result);
  };
}

(0, _focusSource.subscribeFocusEvents)();

var setThemeForSelector = function setThemeForSelector(colors) {
  return {
    background: colors.background,
    borderColor: colors.border,
    color: colors.tick
  };
};

var tickStyle = {
  fill: null,
  width: null,
  height: null
};

var styles = function styles(theme) {
  var checkboxTheme = theme.checkbox;
  var _checkboxTheme$types = checkboxTheme.types,
      regular = _checkboxTheme$types.regular,
      awesome = _checkboxTheme$types.awesome;
  return (0, _extends3.default)({
    checkbox: {
      extend: _mixins.isolateMixin,
      fontFamily: theme.fontFamily,
      fontSize: checkboxTheme.fontSize,
      position: 'relative',
      display: 'inline-block',
      verticalAlign: 'top',
      cursor: 'pointer',
      userSelect: 'none',
      transition: "color ".concat(checkboxTheme.animationDuration, "ms")
    },
    isDisabled: {
      cursor: 'not-allowed',
      pointerEvents: 'none'
    },
    regular: (0, _extends3.default)({
      color: regular.colors.default.text,
      '&$isDisabled': {
        color: regular.colors.disabled.text
      },
      '& $fake': setThemeForSelector(regular.colors.default),
      '&$isEnabled:hover $fake': setThemeForSelector(regular.colors.hover),
      '&$isEnabled:active $fake': setThemeForSelector(regular.colors.active),
      '&$isDisabled $fake': setThemeForSelector(regular.colors.disabled),
      '&$isDisabled$isChecked $fake': setThemeForSelector(regular.colors.checkedDisabled),
      '&$isChecked $fake': setThemeForSelector(regular.colors.checked),
      '&$isChecked:hover $fake': setThemeForSelector(regular.colors.checkedHover),
      '&$isChecked:active $fake': setThemeForSelector(regular.colors.checkedActive)
    }, (0, _mixins.focusSourceMixin)('other', '& $real:focus ~ $fake', setThemeForSelector(regular.colors.focus))),
    awesome: {
      color: awesome.colors.default.text,
      '&$isDisabled': {
        color: awesome.colors.disabled.text
      },
      '& $fake': setThemeForSelector(awesome.colors.default),
      '&$isEnabled:hover $fake': setThemeForSelector(awesome.colors.hover),
      '&$isEnabled$isChecked $fake, &&$indeterminate $fake': setThemeForSelector(awesome.colors.checked),
      '&$isEnabled$isChecked:hover $fake, &$isEnabled$indeterminate:hover $fake': setThemeForSelector(awesome.colors.checkedHover),
      '&$isDisabled $fake': setThemeForSelector(awesome.colors.disabled)
    },
    fake: (0, _extends3.default)({
      display: 'block',
      boxSizing: 'border-box',
      position: 'absolute',
      borderRadius: checkboxTheme.borderRadius,
      borderStyle: 'solid',
      borderWidth: 1,
      lineHeight: 0,
      transitionDuration: checkboxTheme.animationDuration,
      transitionProperty: 'border-color, background-color, color',
      transformStyle: 'preserve-3d'
    }, theme.checkbox.outline && {
      '&:after': {
        content: '""',
        display: 'block',
        position: 'absolute',
        borderRadius: '50%',
        top: '50%',
        left: '50%',
        transform: "translate3d(-50%, -50%, -".concat(theme.checkbox.outline.width, "px)"),
        border: "solid ".concat(theme.checkbox.outline.color),
        borderWidth: 0,
        transitionDuration: 'inherit',
        transitionProperty: 'border-width'
      },
      '$isEnabled:active &:after': {
        borderWidth: theme.checkbox.outline.width
      }
    }, {
      '&:before': {
        position: 'absolute',
        content: '""',
        opacity: 0,
        top: 0,
        right: 0,
        bottom: 0.5,
        left: 0,
        background: 'currentColor',
        height: 2,
        margin: 'auto 2px',
        borderRadius: 1,
        transform: 'scaleX(0.4)',
        transitionDuration: checkboxTheme.animationDuration,
        transitionProperty: 'transform, opacity'
      },
      '$indeterminate &:before': {
        opacity: 1,
        transform: 'scaleX(1)'
      },
      '$iconright &': {
        right: 0
      },
      '$iconleft &': {
        left: 0
      }
    }),
    real: {
      position: 'absolute',
      opacity: 0,
      appearance: 'none',
      pointerEvents: 'none'
    },
    label: {
      fontSize: checkboxTheme.fontSize,
      fontWeight: checkboxTheme.fontWeight,
      display: 'inline-block'
    },
    tick: {
      position: 'absolute',
      fill: 'currentColor',
      opacity: 0,
      transitionDuration: checkboxTheme.animationDuration,
      transitionProperty: 'transform, opacity',
      '$isChecked &': {
        opacity: 1
      }
    },
    isEnabled: {},
    isChecked: {},
    indeterminate: {},
    iconright: {},
    iconleft: {}
  }, ['medium', 'small'].reduce(function (result, size) {
    return (0, _extends3.default)({}, result, (0, _defineProperty2.default)({}, size, {
      '&$checkbox': {
        lineHeight: checkboxTheme.sizes[size].size + 'px'
      },
      '& $fake': (0, _extends3.default)({
        top: size === 'small' ? Math.round((checkboxTheme.sizes[size].lineHeight - checkboxTheme.sizes[size].size) / 2) : Math.round((checkboxTheme.sizes[size].lineHeight - checkboxTheme.sizes[size].size) / 2) - 1,
        width: checkboxTheme.sizes[size].size,
        height: checkboxTheme.sizes[size].size
      }, theme.checkbox.outline && {
        '&:after': {
          width: checkboxTheme.sizes[size].size,
          height: checkboxTheme.sizes[size].size
        }
      }),
      '& $tick': {
        top: Math.round((checkboxTheme.sizes[size].size - checkboxTheme.sizes[size].tickSize) / 2) - 1,
        left: Math.round((checkboxTheme.sizes[size].size - checkboxTheme.sizes[size].tickSize) / 2) - 1,
        width: checkboxTheme.sizes[size].tickSize,
        height: checkboxTheme.sizes[size].tickSize,
        transform: size === 'small' ? "translateY(-".concat(checkboxTheme.sizes[size].tickSize * 0.3, "px)") : "translateY(-".concat(checkboxTheme.sizes[size].tickSize * 0.5, "px)"),
        '$isChecked&': {
          transform: 'translateY(0)'
        }
      },
      '& $label': {
        lineHeight: checkboxTheme.sizes[size].lineHeight + 'px',
        '$iconright&': {
          paddingRight: checkboxTheme.sizes[size].size + checkboxTheme.sizes[size].labelMargin
        },
        '$iconleft&': {
          paddingLeft: checkboxTheme.sizes[size].size + checkboxTheme.sizes[size].labelMargin
        }
      }
    }));
  }, {}));
};

var Checkbox = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(Checkbox, _PureComponent);

  var _super = _createSuper(Checkbox);

  function Checkbox() {
    var _this;

    (0, _classCallCheck2.default)(this, Checkbox);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _this.onChange = function (event) {
      if (_this.props.onCheck) _this.props.onCheck(event, _this.input.checked);
    };

    return _this;
  }

  (0, _createClass2.default)(Checkbox, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.input) this.input.indeterminate = this.props.indeterminate;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.input) this.input.indeterminate = this.props.indeterminate;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          name = _this$props.name,
          style = _this$props.style,
          disabled = _this$props.disabled,
          iconPosition = _this$props.iconPosition,
          className = _this$props.className,
          checkboxClassName = _this$props.checkboxClassName,
          checkboxStyle = _this$props.checkboxStyle,
          labelClassName = _this$props.labelClassName,
          labelStyle = _this$props.labelStyle,
          children = _this$props.children,
          variation = _this$props.variation,
          size = _this$props.size,
          checked = _this$props.checked,
          indeterminate = _this$props.indeterminate,
          classes = _this$props.classes,
          onCheck = _this$props.onCheck,
          theme = _this$props.theme,
          other = (0, _objectWithoutProperties2.default)(_this$props, ["name", "style", "disabled", "iconPosition", "className", "checkboxClassName", "checkboxStyle", "labelClassName", "labelStyle", "children", "variation", "size", "checked", "indeterminate", "classes", "onCheck", "theme"]);
      var resultClassName = (0, _classnames.default)(className, classes.checkbox, classes[variation], classes[size], classes["icon".concat(iconPosition)], disabled ? classes.isDisabled : classes.isEnabled, indeterminate ? classes.indeterminate : checked && classes.isChecked);
      return _react.default.createElement("label", {
        className: resultClassName,
        style: style
      }, _react.default.createElement("input", (0, _extends3.default)({}, other, {
        ref: function ref(input) {
          _this2.input = input;
        },
        checked: checked,
        name: name,
        type: "checkbox",
        className: classes.real,
        disabled: disabled,
        onChange: this.onChange
      })), _react.default.createElement("span", {
        className: (0, _classnames.default)(classes.fake, checkboxClassName),
        style: checkboxStyle
      }, size === 'small' ? _react.default.createElement(_TickIconSmall.default, {
        className: classes.tick,
        style: tickStyle
      }) : _react.default.createElement(_TickIcon.default, {
        className: classes.tick,
        style: tickStyle
      })), _react.default.createElement("span", {
        className: (0, _classnames.default)(classes.label, labelClassName),
        style: labelStyle
      }, children));
    }
  }]);
  return Checkbox;
}(_react.PureComponent);

Checkbox.defaultProps = {
  iconPosition: 'left',
  disabled: false,
  checked: false,
  indeterminate: false,
  name: '',
  variation: 'regular',
  size: 'medium'
};
Checkbox.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Имя чекбокса
   */
  name: _propTypes.default.string,

  /**
   * Отключение чекбокса
   */
  disabled: _propTypes.default.bool,

  /**
   * CSS-класс контейнера
   */
  className: _propTypes.default.string,

  /**
   * Стили контейнера
   */
  style: _propTypes.default.object,

  /**
   * C какой стороны показывать иконку
   */
  iconPosition: _propTypes.default.oneOf(['left', 'right']),

  /**
   * Поставить галочку изначально
   */
  checked: _propTypes.default.bool,

  /**
   * Состояние indeterminate
   */
  indeterminate: _propTypes.default.bool,

  /**
   * Колбек отрабатывающий при изменении checkbox'a
   * `onCheck(event, checked)`
   * Принимает параметры: DOM-события и флаг включения/отключения чекбокса
   */
  onCheck: _propTypes.default.func,

  /**
   * Стиль чекбокса (квадрат с иконкой)
   */
  checkboxStyle: _propTypes.default.object,

  /**
   * Класс чекбокса (квадрат с иконкой)
   */
  checkboxClassName: _propTypes.default.string,

  /**
   * Стиль лейбла
   */
  labelStyle: _propTypes.default.object,

  /**
   * Класс лейбла
   */
  labelClassName: _propTypes.default.string,

  /**
   * Разновидность инпута
   */
  variation: _propTypes.default.oneOf(['regular', 'awesome']),

  /**
   * Размер чекбокса
   */
  size: _propTypes.default.oneOf(['small', 'medium']),

  /**
   * Контент инпута
   */
  children: _propTypes.default.node
} : {};

var _default = (0, _theme.withStyles)(styles, {
  name: 'Checkbox'
})(Checkbox);

exports.default = _default;